import './wilderness/style';
import FormStructure from './wilderness/form_structure';

export default FormStructure;